import ViiluDialog from 'ui/components/ViiluDialog'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import {
	CircularProgress,
	DataTable,
	TableBody,
	TableColumn,
	TableHeader,
	TableRow,
} from 'react-md'
//import useUnit from './useUnit'
import { unitHeaders } from './constants'
import UnitFormInput from './UnitFormInput'
import { CreateFormGrid } from 'ui/ManagerFinance/components'
import { FormProvider, useForm } from 'react-hook-form'
import { useZodValidationResolver } from 'util/hooks/useZodValidationResolver'
import { UnitFormSchema } from './validation'
import type { UnitFormInputs } from './validation'
import { TableContainer } from 'ui/StyledComponents/Tables'

type Props = {
	id?: string | null
	refresh: () => void
	onHide: () => void
}

const UnitDialog = ({
	id,
	//refresh,
	onHide,
}: Props) => {
	const intl = useIntl()
	const [processing, setProcessing] = useState(false)

	//const { unit } = useUnit(id)

	const resolver = useZodValidationResolver<UnitFormInputs>(UnitFormSchema)

	const formMethods = useForm<UnitFormInputs>({
		resolver,
		defaultValues: {},
		mode: 'onBlur',
		shouldUnregister: false,
	})

	const onProcess = async () => {
		setProcessing(true)
		setProcessing(false)
	}

	const renderTableColumns = () => {
		return unitHeaders
			.filter((h) => h.show)
			.map((input, index) => {
				return (
					<TableColumn key={String(input.key)}>
						<CreateFormGrid>
							<UnitFormInput
								key={`${input.key as string}-${index}`} //TODO: REMOVE AS STRING
								input={input}
							/>
						</CreateFormGrid>
					</TableColumn>
				)
			})
	}

	const renderTableRows = () => {
		//TODO: LOOP ROWS
		return <TableRow>{renderTableColumns()}</TableRow>
	}

	const renderTableHeaders = () => {
		return (
			<TableRow>
				{unitHeaders
					.filter((h) => h.show)
					.map((header) => (
						//@ts-ignore //TODO: REMOVE
						<TableColumn key={header.key}>
							<p className="text-strong text-subtle">{header.title(intl)}</p>
						</TableColumn>
					))}
				<TableColumn key={'children-header'}>+</TableColumn>
			</TableRow>
		)
	}

	const renderTable = () => {
		return (
			<TableContainer>
				<DataTable
					plain
					style={{
						background: 'white',
						maxHeight: 'calc(100vh - 205px)',
					}}
				>
					<TableHeader
						style={{
							position: 'sticky',
							top: 0,
							zIndex: 1,
							background: 'white',
						}}
					>
						{renderTableHeaders()}
					</TableHeader>
					<TableBody>{renderTableRows()}</TableBody>
				</DataTable>
			</TableContainer>
		)
	}

	const renderChildren = () => {
		return (
			<div
				className="margin-left--lg margin-right--lg"
				style={{ paddingBottom: 64 }}
			>
				<FormProvider {...formMethods}>{renderTable()}</FormProvider>
			</div>
		)
	}

	const actions = [
		{
			id: 'dialog-cancel',
			children: intl.formatMessage({
				defaultMessage: 'Peruuta',
				description: 'Cancel button',
			}),
			onClick: onHide,
		},
		{
			id: 'dialog-ok',
			secondary: true,
			children: processing ? (
				<CircularProgress id="progress" style={{ marginTop: 0 }} />
			) : (
				intl.formatMessage({
					defaultMessage: 'Tallenna',
					description: 'Save button',
				})
			),
			onClick: onProcess,
		},
	]

	return (
		<ViiluDialog
			id="responsive-dialog"
			title={
				id
					? intl.formatMessage({
							defaultMessage: 'Muokkaa yksikköä',
							description: 'Title of edit unit',
					  })
					: intl.formatMessage({
							defaultMessage: 'Lisää yksikkö',
							description: 'Title of add unit',
					  })
			}
			visible={true}
			actions={actions}
			onHide={onHide}
			focusOnMount={true}
			containFocus={true}
			dialogClassName="responsive-dialog"
			contentClassName="responsive-dialog-content"
			autosizeContent={false}
			modal
			portal
			paddedContent
		>
			{renderChildren()}
		</ViiluDialog>
	)
}

export default UnitDialog
